import React, { useEffect, useState, useCallback, useRef } from 'react';
import Container from '../../../Container/Container';
import { useNavigate, useLocation } from 'react-router';
import { useForm, Controller } from "react-hook-form";
import { get } from '../../../ApiServices/ApiServices';
import Select from 'react-select';
import 'react-datepicker/dist/react-datepicker.css';
import { useDispatch, useSelector } from 'react-redux';
import { updateAddress } from '../../../redux/profileSlice';
import { GOOGLE_MAPS_API_KEY } from '../../../ApiServices/ApiServices';
function MemberDetail({ onNext, ticket, initialValues }) {
    const { register, handleSubmit, setValue, control: mainControl, reset, watch, formState: { errors } } = useForm({
        defaultValues: initialValues
    });

    const profile = useSelector((state) => state.profile.profile);
    const location = useLocation();
    const [Gettype, setGettype] = useState([]);
    // Google Maps Autocomplete States for main form
    const [isGoogleMapsLoaded, setIsGoogleMapsLoaded] = useState(false);
    const [autocomplete, setAutocomplete] = useState(null);
    const [isAddressManuallyEdited, setIsAddressManuallyEdited] = useState(false);

    // Google Maps Autocomplete States for modal
    const [modalAutocomplete, setModalAutocomplete] = useState(null);
    const [isModalAddressManuallyEdited, setIsModalAddressManuallyEdited] = useState(false);

    // US States mapping
    const US_STATES_MAP = {
        'AL': 'Alabama', 'AK': 'Alaska', 'AZ': 'Arizona', 'AR': 'Arkansas',
        'CA': 'California', 'CO': 'Colorado', 'CT': 'Connecticut', 'DE': 'Delaware',
        'FL': 'Florida', 'GA': 'Georgia', 'HI': 'Hawaii', 'ID': 'Idaho',
        'IL': 'Illinois', 'IN': 'Indiana', 'IA': 'Iowa', 'KS': 'Kansas',
        'KY': 'Kentucky', 'LA': 'Louisiana', 'ME': 'Maine', 'MD': 'Maryland',
        'MA': 'Massachusetts', 'MI': 'Michigan', 'MN': 'Minnesota', 'MS': 'Mississippi',
        'MO': 'Missouri', 'MT': 'Montana', 'NE': 'Nebraska', 'NV': 'Nevada',
        'NH': 'New Hampshire', 'NJ': 'New Jersey', 'NM': 'New Mexico', 'NY': 'New York',
        'NC': 'North Carolina', 'ND': 'North Dakota', 'OH': 'Ohio', 'OK': 'Oklahoma',
        'OR': 'Oregon', 'PA': 'Pennsylvania', 'RI': 'Rhode Island', 'SC': 'South Carolina',
        'SD': 'South Dakota', 'TN': 'Tennessee', 'TX': 'Texas', 'UT': 'Utah',
        'VT': 'Vermont', 'VA': 'Virginia', 'WA': 'Washington', 'WV': 'West Virginia',
        'WI': 'Wisconsin', 'WY': 'Wyoming', 'DC': 'District of Columbia'
    };

    // Google Maps API Key - Replace with your actual key

    // Load Google Maps Script
    const loadGoogleMapsScript = () => {
        if (window.google && window.google.maps) {
            setIsGoogleMapsLoaded(true);
            return;
        }

        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places`;
        script.async = true;
        script.defer = true;
        script.onload = () => setIsGoogleMapsLoaded(true);
        document.head.appendChild(script);
    };

    // Initialize Autocomplete for main form
    const initializeAutocomplete = () => {
        if (!window.google || !window.google.maps) {
            console.error('Google Maps not loaded');
            return;
        }

        const addressInput = document.getElementById('address-input-member');
        if (!addressInput) {
            console.error('Address input not found');
            return;
        }

        // Clear existing autocomplete if any
        if (autocomplete) {
            const parent = addressInput.parentNode;
            const newInput = addressInput.cloneNode(true);
            parent.replaceChild(newInput, addressInput);
            newInput.value = watch("Address") || "";
            newInput.addEventListener('change', handleAddressChange);
            newInput.addEventListener('blur', () => { });
        }

        // Initialize new autocomplete
        const newAutocomplete = new window.google.maps.places.Autocomplete(
            addressInput,
            {
                types: ['address'],
                componentRestrictions: { country: 'us' }
            }
        );

        newAutocomplete.addListener('place_changed', () => handlePlaceSelect(newAutocomplete));
        setAutocomplete(newAutocomplete);
    };

    // Initialize Autocomplete for modal
    const initializeModalAutocomplete = () => {
        if (!window.google || !window.google.maps) {
            console.error('Google Maps not loaded');
            return;
        }

        const modalAddressInput = document.getElementById('modal-address-input');
        if (!modalAddressInput) {
            console.error('Modal address input not found');
            return;
        }

        // Remove existing autocomplete listener if any
        if (modalAutocomplete) {
            window.google.maps.event.clearInstanceListeners(modalAddressInput);
        }

        // Initialize new modal autocomplete
        const newModalAutocomplete = new window.google.maps.places.Autocomplete(
            modalAddressInput,
            {
                types: ['address'],
                componentRestrictions: { country: 'us' }
            }
        );

        newModalAutocomplete.addListener('place_changed', () => handleModalPlaceSelect(newModalAutocomplete));
        setModalAutocomplete(newModalAutocomplete);

        console.log('Modal autocomplete initialized successfully');
    };

    // Handle place selection from autocomplete for main form
    const handlePlaceSelect = (autocompleteInstance) => {
        const place = autocompleteInstance.getPlace();

        if (!place.geometry) {
            console.error('No details available for this address');
            return;
        }

        // Extract address components
        let streetNumber = '';
        let route = '';
        let city = '';
        let stateCode = '';
        let stateName = '';
        let zipCode = '';

        place.address_components.forEach(component => {
            const types = component.types;

            if (types.includes('street_number')) {
                streetNumber = component.long_name;
            } else if (types.includes('route')) {
                route = component.long_name;
            } else if (types.includes('locality')) {
                city = component.long_name;
            } else if (types.includes('administrative_area_level_1')) {
                stateCode = component.short_name;
                stateName = component.long_name;
            } else if (types.includes('postal_code')) {
                zipCode = component.long_name;
            }
        });

        // Build full address
        const fullAddress = streetNumber && route ? `${streetNumber} ${route}` : place.name;

        // Convert state code to full state name
        const fullStateName = US_STATES_MAP[stateCode] || stateName;

        // Mark that this was an autocomplete selection
        setIsAddressManuallyEdited(false);

        // Update form values
        setValue("Address", fullAddress);
        setValue("City", city);
        setValue("State", fullStateName);
        setValue("ZipCode", zipCode);
    };

    // Handle place selection from autocomplete for modal
    const handleModalPlaceSelect = (autocompleteInstance) => {
        const place = autocompleteInstance.getPlace();
        if (!place.geometry) {
            console.error('No details available for this address');
            return;
        }

        // Extract address components
        let streetNumber = '';
        let route = '';
        let city = '';
        let stateCode = '';
        let stateName = '';
        let zipCode = '';

        place.address_components.forEach(component => {
            const types = component.types;

            if (types.includes('street_number')) {
                streetNumber = component.long_name;
            } else if (types.includes('route')) {
                route = component.long_name;
            } else if (types.includes('locality')) {
                city = component.long_name;
            } else if (types.includes('administrative_area_level_1')) {
                stateCode = component.short_name;
                stateName = component.long_name;
            } else if (types.includes('postal_code')) {
                zipCode = component.long_name;
            }
        });

        // Build full address
        const fullAddress = streetNumber && route ? `${streetNumber} ${route}` : place.name;

        // Convert state code to full state name
        const fullStateName = US_STATES_MAP[stateCode] || stateName;

        // Mark that this was an autocomplete selection
        setIsModalAddressManuallyEdited(false);

        // Update modal form values using setShippingValue from the shipping form
        setShippingValue("addressLine1", fullAddress);
        setShippingValue("city", city);
        setShippingValue("state", fullStateName);
        setShippingValue("zipCode", zipCode);
    };

    // Handle manual address input change for main form
    const handleAddressChange = (e) => {
        setValue("Address", e.target.value);
        setIsAddressManuallyEdited(true);

        // Clear dependent fields if address is cleared
        if (!e.target.value && !isAddressManuallyEdited) {
            setValue("City", "");
            setValue("State", "");
            setValue("ZipCode", "");
        }
    };

    // Handle manual address input change for modal
    const handleModalAddressChange = (e) => {
        setShippingValue("addressLine1", e.target.value);
        setIsModalAddressManuallyEdited(true);

        // Clear dependent fields if address is cleared
        if (!e.target.value && !isModalAddressManuallyEdited) {
            setShippingValue("city", "");
            setShippingValue("state", "");
            setShippingValue("zipCode", "");
        }
    };

    // Handle manual changes to other address fields for main form
    const handleCityChange = (e) => {
        setValue("City", e.target.value);
        setIsAddressManuallyEdited(true);
    };

    const handleStateChange = (selectedOption) => {
        const value = selectedOption ? selectedOption.value : '';
        setValue("State", value);
        setIsAddressManuallyEdited(true);
    };

    const handleZipChange = (e) => {
        setValue("ZipCode", e.target.value);
        setIsAddressManuallyEdited(true);
    };

    // Handle manual changes to other address fields for modal
    const handleModalCityChange = (e) => {
        setShippingValue("city", e.target.value);
        setIsModalAddressManuallyEdited(true);
    };

    const handleModalStateChange = (selectedOption) => {
        const value = selectedOption ? selectedOption.value : '';
        setShippingValue("state", value);
        setIsModalAddressManuallyEdited(true);
    };

    const handleModalZipChange = (e) => {
        setShippingValue("zipCode", e.target.value);
        setIsModalAddressManuallyEdited(true);
    };

    // Load Google Maps when component mounts
    useEffect(() => {
        loadGoogleMapsScript();
    }, []);

    // Initialize autocomplete when Google Maps is loaded
    useEffect(() => {
        if (isGoogleMapsLoaded && window.google) {
            initializeAutocomplete();
        }
    }, [isGoogleMapsLoaded]);

    // Re-initialize autocomplete when component becomes ready
    useEffect(() => {
        if (isGoogleMapsLoaded && window.google) {
            const timer = setTimeout(() => {
                initializeAutocomplete();
            }, 500);

            return () => clearTimeout(timer);
        }
    }, [isGoogleMapsLoaded, initialValues]);

    const Viewtype = async () => {
        try {
            const api = `all-wedding-roles`;
            const response = await get(api);
            console.log(response.data)
            if (response?.message == "success") {
                setGettype(response.data);
            }
        } catch (err) {

            console.error('Errordsfdsfd:', err);
        } finally {
            console.log("first")
        }
    };
    useEffect(() => {
        Viewtype();
    }, []);
    // Initialize modal autocomplete when modal is shown
    useEffect(() => {
        const modalElement = document.getElementById('dropShipping');
        if (!modalElement) return;

        const handleModalShown = () => {
            if (isGoogleMapsLoaded && window.google) {
                setTimeout(() => {
                    initializeModalAutocomplete();
                }, 300);
            }
        };

        modalElement.addEventListener('shown.bs.modal', handleModalShown);

        return () => {
            modalElement.removeEventListener('shown.bs.modal', handleModalShown);
        };
    }, [isGoogleMapsLoaded]);

    const [dropShippingData, setDropShippingData] = useState(initialValues?.dropShipping || null);
    const [dropShippingModalClosed, setDropShippingModalClosed] = useState(false);
    const [dropShippingError, setDropShippingError] = useState("");

    // Re-initialize modal autocomplete when dropShippingData changes
    useEffect(() => {
        if (isGoogleMapsLoaded && window.google) {
            const timer = setTimeout(() => {
                initializeModalAutocomplete();
            }, 1500);

            return () => clearTimeout(timer);
        }
    }, [isGoogleMapsLoaded, dropShippingData]);

    // Rest of your existing component code remains the same...
    const { register: registerShipping, handleSubmit: handleSubmitShipping, control, formState: { errors: shippingErrors }, reset: resetShipping, setValue: setShippingValue } = useForm({
        defaultValues: {
            name: initialValues?.dropShipping?.name || "",
            addressLine1: initialValues?.dropShipping?.addressLine1 || "",
            addressLine2: initialValues?.dropShipping?.addressLine2 || "",
            city: initialValues?.dropShipping?.city || "",
            phone: initialValues?.dropShipping?.phone || "",
            state: initialValues?.dropShipping?.state || "",
            zipCode: initialValues?.dropShipping?.zipCode || "",
        }
    });
    useEffect(() => {
        if (initialValues?.wedding_role_id && Gettype.length > 0) {
            setValue("weddingRole", String(initialValues.wedding_role_id));
        }
    }, [initialValues?.wedding_role_id, Gettype, setValue]);

    useEffect(() => {
        setDropShippingData(initialValues?.dropShipping || null)
    }, [initialValues?.dropShipping])

    useEffect(() => {
        if (initialValues?.dropShipping) {
            resetShipping({
                name: initialValues?.dropShipping?.name || "",
                addressLine1: initialValues?.dropShipping?.addressLine1 || "",
                addressLine2: initialValues?.dropShipping?.addressLine2 || "",
                city: initialValues?.dropShipping?.city || "",
                phone: initialValues?.dropShipping?.phone || "",
                state: initialValues?.dropShipping?.state || "",
                zipCode: initialValues?.dropShipping?.zipCode || "",
            });
        }
    }, [initialValues, resetShipping]);

    const [isDropShipping, setIsDropShipping] = useState(initialValues?.dropShippingswitch || false);
    const editButtonRef = useRef(null);

    useEffect(() => {
        if (initialValues?.dropShippingswitch !== undefined) {
            setIsDropShipping(initialValues.dropShippingswitch);
            if (initialValues?.dropShippingswitch == true) {
                setIsDropShipping(true)
            }
        }
    }, [initialValues?.dropShippingswitch]);

    const [isChecked, setIsChecked] = useState(false);
    const [Accountdata, setAccountdata] = useState([])

    const currentAccount = watch("AccountId");
    const ViewSingleData = async (id) => {
        try {
            const api = `view-customer/${id}`;
            const totalData = await get(api);
            if (totalData?.status == true) {
                setAccountdata(totalData?.data)
            }
        } catch (err) {
            if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
        } finally {
        }
    };

    useEffect(() => {
        if (profile?.name != "Admin") {
            ViewSingleData(profile?.id);
        }
        else {
            ViewSingleData(currentAccount);
        }
    }, [profile?.id, currentAccount]);

    useEffect(() => {
        if (initialValues?.AlternatePickup !== undefined) {
            setIsChecked(initialValues.AlternatePickup);
        }
    }, [initialValues?.AlternatePickup]);

    const [order, setorder] = useState([])
    const [address, setaddress] = useState('')
    const [selectedAddress, setSelectedAddress] = useState('');
    const [openToDate, setOpenToDate] = useState(null);
    const dispatch = useDispatch();
    const [Customers, setCustomers] = useState([])
    const navigate = useNavigate();
    const [getState, setGetState] = useState([]);
    const [selectedCompany, setError] = useState("");
    const AlterAcc = watch("AlterAcc")

    useEffect(() => {
        if (selectedAddress) {
            const formattedAddress = selectedAddress.split("- Account:")[0];
            dispatch(updateAddress(formattedAddress));
        }
    }, [selectedAddress])

    useEffect(() => {
        ViewState();
        reset(initialValues);
        if (initialValues?.dropShipping?.enabled) {
            setIsDropShipping(true);
            setDropShippingData(initialValues.dropShipping);
            resetShipping(initialValues.dropShipping);
        }
    }, [initialValues, reset, resetShipping]);

    useEffect(() => {
        if (order.length > 0 && isChecked && initialValues?.Affiliated_store) {
            const affiliatedStoreName = initialValues.Affiliated_store;
            const selectedCompanyData = order.find(data => data.companyName === affiliatedStoreName);

            if (selectedCompanyData) {
                const companyId = selectedCompanyData.id;
                setValue("Affiliated_store", affiliatedStoreName);
                setValue('store_id', companyId);

                const fetchAffiliatedStoreData = async () => {
                    try {
                        const api = `all-group-customers/${companyId}`;
                        const response = await get(api);
                        if (response?.status === true) {
                            setaddress(response.data);
                        }
                    } catch (err) {
                        console.error('Error:', err);
                    }

                    const address = selectedCompanyData?.addresses?.[0];
                    if (address) {
                        setSelectedAddress(
                            `${address.billingAddress || ''}, ${address.billingAddressLine2 || ''}, ${address.billingCity || ''} 
                             ${address.billingState || ''}, ${address.billingZip || ''} - Account: ${selectedCompanyData.account || 'N/A'}`
                        );
                    } else {
                        setSelectedAddress("No Address Available - Account: ${selectedCompanyData.account || 'N/A'}");
                    }
                };

                fetchAffiliatedStoreData();
            }
        }
    }, [order, isChecked, initialValues, setValue]);

    const onDropShippingSubmit = (data) => {
        setDropShippingData(data);
        setIsDropShipping(true);
        document.querySelector('[data-bs-dismiss="modal"]').click();
    };

    const onSubmit = (data) => {
        if (data.AlternatePickup && !data.Affiliated_store) {
            setError("Affiliated_store", {
                type: "manual",
                message: "Please select an affiliated store"
            });
            return;
        }
        if (isDropShipping && !dropShippingData?.addressLine1) {
            setDropShippingError("Please enter drop shipping address or turn off drop shipping.");
            return;
        }
        const mergedData = {
            ...data,
            dropShipping: isDropShipping ? {
                enabled: true,
                ...dropShippingData
            } : {
                enabled: false,
                name: "",
                addressLine1: "",
                addressLine2: "",
                city: "",
                state: "",
                zipCode: "",
                phone: ""
            }
        };
        onNext(mergedData);
    };

    const handleCheckboxChange = (e) => {
        setIsChecked(!isChecked);
        if (e.target.checked) {
            setValue('AlternatePickup', true);
            setValue('dropShippingswitch', false);
        } else {
            setValue('AlternatePickup', false);
            setValue('Affiliated_store', "")
            setaddress('');
            setSelectedAddress('');
        }
        if (e.target.checked) {
            setIsDropShipping(false);
        }
    };

    // const handleDropShippingToggle = (e) => {
    //     if (!e.target.checked) {
    //     } else {
    //         setValue('AlternatePickup', false);
    //         setValue('Affiliated_store', "")
    //     }

    //     if (e.target.checked) {
    //         setValue('dropShippingswitch', true);
    //         setIsDropShipping(true);
    //     } else {
    //         setValue('dropShippingswitch', false);
    //         setIsDropShipping(false);
    //     }

    //     if (!e.target.checked) {
    //         setIsDropShipping(false);
    //     } else {
    //         if (!dropShippingData) {
    //             const modal = document.querySelector('#dropShipping');
    //             if (modal) {
    //             }
    //         }
    //         setIsDropShipping(true);
    //         setIsChecked(false)
    //     }
    // };
    const handleDropShippingToggle = (e) => {
        const isCheckedNow = e.target.checked;

        if (!isCheckedNow) {
            // Turning OFF drop shipping
            setDropShippingError("");
            setValue('dropShippingswitch', false);
            setIsDropShipping(false);
            setDropShippingData(null);
        } else {
            // Turning ON drop shipping
            setValue('AlternatePickup', false);
            setValue('Affiliated_store', "");
            setValue('dropShippingswitch', true);
            setIsDropShipping(true);
            setIsChecked(false);

            // Clear any previous errors
            setDropShippingError("");
        }
    };
    const ViewState = async () => {
        try {
            const api = `get-states`;
            const response = await get(api);
            if (response?.message === "success") {
                setGetState(response.data);
            }
        } catch (err) {
            if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
        }
    };

    const affilatedorder = async () => {
        try {
            const api = `all-group-customers/${profile?.name != "Admin" ? profile?.id : currentAccount}`;
            const response = await get(api);

            if (response?.status == true) {
                setorder(response?.data?.rows);
            }
        } catch (err) {
            console.error('Error:', err);
        }
    };

    useEffect(() => {
        affilatedorder()
    }, [currentAccount])

    const formatPhoneNumber = (input) => {
        const cleaned = input.replace(/\D/g, '');
        if (cleaned.length === 0) return '';
        if (cleaned.length <= 3) return `(${cleaned}`;
        if (cleaned.length <= 6) return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
        return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
    };

    const handleChange = (e) => {
        const formatted = formatPhoneNumber(e.target.value);
        if (formatted.length <= 14) {
            e.target.value = formatted;
        }
    };

    const formatPhoneNumbermo = (input) => {
        const cleaned = input.replace(/\D/g, '');
        if (cleaned.length === 0) return '';
        if (cleaned.length <= 3) return `(${cleaned}`;
        if (cleaned.length <= 6) return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
        return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
    };

    const handleChangemo = (e) => {
        const formatted = formatPhoneNumbermo(e.target.value);
        if (formatted.length <= 14) {
            e.target.value = formatted;
        }
    };

    const handleSelectChange = async (event) => {
        const selectedCompanyName = event.target.value;
        if (selectedCompanyName === "") {
            setaddress('');
            setSelectedAddress('');
        } else {
            const selectedCompanyData = order.find(data => data.companyName === selectedCompanyName);

            if (selectedCompanyData) {
                const companyId = selectedCompanyData.id;
                setValue('store_id', companyId)

                const address = selectedCompanyData?.addresses?.[0];
                if (address) {
                    setSelectedAddress(
                        `${address.billingAddress || ''}, ${address.billingAddressLine2 || ''} ${address.billingAddressLine2 && ','} ${address.billingCity || ''},
                             ${address.billingState || ''}, ${address.billingZip || ''} - Account: ${selectedCompanyData.account || 'N/A'}`
                    );
                } else {
                    setSelectedAddress("No Address Available - Account: ${selectedCompanyData.account || 'N/A'}");
                }
            }
        }
    };

    const [minDate, setMinDate] = useState(null);
    const [blockedDates, setBlockedDates] = useState([]);

    const GetCustomers = async () => {
        try {
            const api = `all-customers?size=1000`;
            const totalData = await get(api);

            if (totalData?.status === true) {
                setCustomers(totalData?.data?.rows || []);
            }
        } catch (err) {
            console.error('Error:', err.message);
            if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
        }
    };

    useEffect(() => {
        GetCustomers()
    }, [])

    useEffect(() => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const dayOfWeek = today.getDay();
        let blockedDatesArray = [];

        if (dayOfWeek >= 0 && dayOfWeek <= 3) {
            const daysUntilNextTuesday = dayOfWeek === 0 ? 9 : (9 - dayOfWeek);
            for (let i = 0; i <= daysUntilNextTuesday; i++) {
                const blockedDate = new Date(today);
                blockedDate.setDate(today.getDate() + i);
                blockedDatesArray.push(blockedDate.getTime());
            }
        } else if (dayOfWeek >= 4 && dayOfWeek <= 6) {
            const daysUntil2ndTuesday = 16 - dayOfWeek;
            for (let i = 0; i <= daysUntil2ndTuesday; i++) {
                const blockedDate = new Date(today);
                blockedDate.setDate(today.getDate() + i);
                blockedDatesArray.push(blockedDate.getTime());
            }
        }

        setBlockedDates(blockedDatesArray);
        setMinDate(today);

        let nextAvailableDate = new Date(today);
        while (blockedDatesArray.includes(nextAvailableDate.getTime())) {
            nextAvailableDate.setDate(nextAvailableDate.getDate() + 1);
        }
        setOpenToDate(nextAvailableDate);
    }, []);

    useEffect(() => {
        if (initialValues?.dropShipping?.name) {
            setValue("name", initialValues.dropShipping.name);
        }
    }, [initialValues, setValue]);

    return (
        <Container>
            <div className="nk-content">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        <div className="nk-content-body">
                            <div className="nk-block-head nk-block-head-sm">
                                <div className="nk-block-between">
                                    <div className="nk-block-head-content">
                                        <h3 className="nk-block-title page-title">{location.pathname == "/add-order" ? "Add" : "Update"} Member {(ticket && location.pathname != "/add-order") && `#${ticket}`}</h3>
                                    </div>
                                </div>
                            </div>

                            <div className="card card-full">
                                <div className="card-inner">
                                    <div className="stepperLeft">
                                        <div className="row">
                                            <div className="col-md-4 brIght">
                                                <section className="section1">
                                                    <header>
                                                        <div className="bead current"><span>1</span></div> {location.pathname == "/add-order" ? "Add" : "Update"} Member
                                                    </header>
                                                </section>
                                                <section className="section2">
                                                    <header>
                                                        <div className="bead"><span>2</span></div>{location.pathname == "/add-order" ? "Add" : "Update"} Sizes
                                                    </header>
                                                </section>
                                                <section>
                                                    <header>
                                                        <div className="bead"><span>3</span></div> {location.pathname == "/add-order" ? "Add" : "Update"} Notes
                                                    </header>
                                                </section>
                                            </div>

                                            <div className="col-md-8">
                                                {/* <h4>{location.pathname == "/add-order" ? "Add" : "Update"} Member </h4> */}
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <h4>
                                                        {location.pathname == "/add-order" ? "Add" : "Update"} Member
                                                    </h4>

                                                    <button
                                                        type="button"
                                                        onClick={() => navigate(-1)}
                                                        className="btn btn-outline-light"
                                                    >
                                                        <em className="icon ni ni-arrow-left"></em> Back
                                                    </button>
                                                </div>
                                                <form onSubmit={handleSubmit(onSubmit)}>
                                                    <div className="inputCardBox mt-4">
                                                        <div className="row">
                                                            <div className="col-6 col-md-6 mb-3">
                                                                <label>First Name <span className="text-red-500">*</span></label>
                                                                <input
                                                                    type="text"
                                                                    placeholder="Enter first name"
                                                                    {...register("Firstname", {
                                                                        required: "First name is required",
                                                                        pattern: {
                                                                            value: /^[A-Za-z0-9 ]+$/,
                                                                            message: "Only letters and numbers are allowed"
                                                                        }
                                                                    })}
                                                                />
                                                                {errors.Firstname && <p className='red'>{errors.Firstname.message}</p>}
                                                            </div>

                                                            <div className="col-6 col-md-6 mb-3">
                                                                <label>Last Name <span className="text-red-500">*</span></label>
                                                                <input
                                                                    type="text"
                                                                    placeholder="Enter last name"
                                                                    {...register("Lastname", {
                                                                        required: "Last name is required",
                                                                        pattern: {
                                                                            value: /^[A-Za-z0-9 ]+$/,
                                                                            message: "Only letters and numbers are allowed"
                                                                        }
                                                                    })}
                                                                />
                                                                {errors.Lastname && <p className='red'>{errors.Lastname.message}</p>}
                                                            </div>

                                                            {/* Updated Address Field with Google Maps Autocomplete */}
                                                            <div className="col-md-6 mb-3">
                                                                <label>Address <span className="text-red-500"></span></label>
                                                                <input
                                                                    id="address-input-member"
                                                                    type="text"
                                                                    placeholder="Start typing address..."
                                                                    className="w-full p-2 border border-gray-200 rounded focus:outline-none focus:border-blue-500"
                                                                    onChange={handleAddressChange}
                                                                    value={watch("Address") || ""}
                                                                />
                                                                <div className="text-xs text-gray-500 mt-1">
                                                                    Start typing to see address suggestions
                                                                </div>
                                                            </div>

                                                            <div className="col-md-6 mb-3 stateSelect">
                                                                <label>State <span className="text-red-500"></span></label>
                                                                <Controller
                                                                    name="State"
                                                                    control={mainControl}
                                                                    render={({ field, fieldState: { error } }) => (
                                                                        <div>
                                                                            <Select
                                                                                {...field}
                                                                                options={getState.map(item => ({
                                                                                    value: item.name,
                                                                                    label: item.name
                                                                                }))}
                                                                                placeholder="Select state"
                                                                                isClearable
                                                                                onChange={handleStateChange}
                                                                                value={getState.map(item => ({
                                                                                    value: item.name,
                                                                                    label: item.name
                                                                                })).find(option => option.value === field.value) || null}
                                                                                className={error ? 'is-invalid' : ''}
                                                                            />
                                                                            {error && <p className="red">{error.message}</p>}
                                                                        </div>
                                                                    )}
                                                                />
                                                            </div>

                                                            <div className="col-6 col-md-6 mb-3">
                                                                <label>City <span className="text-red-500"></span></label>
                                                                <input
                                                                    type="text"
                                                                    placeholder="Enter city"
                                                                    {...register("City")}
                                                                    onChange={handleCityChange}
                                                                    value={watch("City") || ""}
                                                                />
                                                                {errors.City && <p className='red'>{errors.City.message}</p>}
                                                            </div>

                                                            <div className="col-6 col-md-6 mb-3">
                                                                <label>Zip Code <span className="text-red-500"></span></label>
                                                                <input
                                                                    type="text"
                                                                    placeholder="Enter zip code"
                                                                    {...register("ZipCode", {
                                                                        pattern: {
                                                                            value: /^\d+$/,
                                                                            message: "Zip code must be a number"
                                                                        }
                                                                    })}
                                                                    onInput={handleZipChange}
                                                                    value={watch("ZipCode") || ""}
                                                                />
                                                                {errors.ZipCode && <p className='red'>{errors.ZipCode.message}</p>}
                                                            </div>

                                                            {/* Rest of your form fields remain the same */}
                                                            <div className="col-md-6 mb-3">
                                                                <label>Phone Number <span className="text-red-500"></span></label>
                                                                <input
                                                                    type="text"
                                                                    className={`w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 
                                                                        ${errors.PhoneNumber ? 'border-red-500' : 'border-gray-300'}`}
                                                                    placeholder="(XXX) XXX-XXXX"
                                                                    maxLength="14"
                                                                    defaultValue={initialValues.PhoneNumber}
                                                                    {...register('PhoneNumber', {
                                                                        onChange: handleChange,
                                                                        pattern: {
                                                                            value: /^\(\d{3}\) \d{3}-\d{4}$/,
                                                                            message: "Please enter a valid phone number"
                                                                        }
                                                                    })}
                                                                />
                                                                {errors.PhoneNumber && (
                                                                    <p className="text-red-500 text-sm">{errors.PhoneNumber.message}</p>
                                                                )}
                                                            </div>

                                                            <div className="col-md-6 mb-3">
                                                                <label>Email Address <span className="text-red-500"></span></label>
                                                                <input type="text" placeholder="Enter email" {...register("EmailAddress", {
                                                                    pattern: {
                                                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                                        message: "Please enter a valid email address"
                                                                    }
                                                                })} />
                                                                {errors.EmailAddress && <p className='red'>{errors.EmailAddress.message}</p>}
                                                            </div>

                                                            {profile?.name === "Admin" && (
                                                                <div className="col-md-6 mb-3 stateSelect">
                                                                    <label>Account Number  <span className="text-red-500">*</span></label>
                                                                    <Controller
                                                                        name="AlterAcc"
                                                                        control={mainControl}
                                                                        defaultValue={AlterAcc || ""}
                                                                        rules={{
                                                                            required: "Account number is required"
                                                                        }}
                                                                        render={({ field, fieldState: { error } }) => {
                                                                            const options = Customers.map(item => ({
                                                                                value: String(item.account),
                                                                                label: `${item.account} (${item.companyName})`
                                                                            }));

                                                                            const selectedOption = options.find(
                                                                                option => option.value === String(field.value)
                                                                            );

                                                                            return (
                                                                                <div>
                                                                                    <Select
                                                                                        options={options}
                                                                                        value={selectedOption || null}
                                                                                        onChange={(selected) => {
                                                                                            setSelectedAddress(null);
                                                                                            setValue("Affiliated_store", "");
                                                                                            if (!selected) {
                                                                                                field.onChange("");
                                                                                                setValue("AccountId", "");
                                                                                                return;
                                                                                            }

                                                                                            const selectedValue = selected.value;
                                                                                            const selectedCustomer = Customers.find(
                                                                                                c => String(c.account) === String(selectedValue)
                                                                                            );
                                                                                            const selectedId = selectedCustomer ? String(selectedCustomer.id) : "";
                                                                                            field.onChange(selectedValue);
                                                                                            setValue("AccountId", selectedId);
                                                                                        }}
                                                                                        placeholder="Select account"
                                                                                        isClearable
                                                                                        isDisabled={location.pathname == "/add-wedding-order" ? false : true}
                                                                                        menuPortalTarget={document.body}
                                                                                    />
                                                                                    {error && (
                                                                                        <div className='red'>
                                                                                            {error.message}
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            );
                                                                        }}
                                                                    />
                                                                </div>
                                                            )}
                                                            <div className="col-6 col-md-6 mb-3">
                                                                <label>Wedding Role <span className="text-red-500"></span></label>
                                                                <select
                                                                    className={`form-control text-dark ${errors.weddingRole ? "is-invalid" : ""}`}
                                                                    {...register("weddingRole", { required: "Please select wedding role" })}
                                                                >
                                                                    <option value="">Select</option>
                                                                    {
                                                                        Gettype.map((data) => {
                                                                            return (
                                                                                <>
                                                                                    <option value={data?.id}>{data?.name}</option>
                                                                                </>
                                                                            )
                                                                        })
                                                                    }

                                                                </select>
                                                                {errors.weddingRole && (
                                                                    <div className="invalid-feedback">{errors.weddingRole.message}</div>
                                                                )}
                                                            </div>
                                                            {/* Rest of your component remains the same */}
                                                            <div className="row mt-3 mpadd ">
                                                                {
                                                                    Accountdata?.isAltPickupEnable == true &&
                                                                    <div className="col-md-5 mb-2 mpadd">
                                                                        <div className="custom-control custom-control-sm custom-switch">
                                                                            <input
                                                                                type="checkbox"
                                                                                className="custom-control-input"
                                                                                id="customSwitch7"
                                                                                checked={isChecked}
                                                                                onChange={handleCheckboxChange}
                                                                            />
                                                                            <label className="custom-control-label" htmlFor="customSwitch7">
                                                                                Alternate Pickup Location
                                                                            </label>
                                                                        </div>

                                                                        {
                                                                            isChecked && <>
                                                                                <div className="mt-2">
                                                                                    <label>Affiliated Store</label><span className="text-red-500">*</span>
                                                                                    <select  {...register("Affiliated_store", {
                                                                                        required: isChecked ? "Please select an affiliated store" : false
                                                                                    })} onChange={handleSelectChange} className={errors.Affiliated_store ? "is-invalid" : ""}>
                                                                                        <option value="">Select a Company</option>
                                                                                        {order.length > 0 ? (
                                                                                            order.map((data) => (
                                                                                                <option key={data.id} value={data.companyName}>
                                                                                                    {data.companyName}
                                                                                                </option>
                                                                                            ))
                                                                                        ) : (
                                                                                            <option disabled>No affiliated stores found</option>
                                                                                        )}
                                                                                    </select>
                                                                                    {errors.Affiliated_store && (
                                                                                        <p className="text-red-500">{errors.Affiliated_store.message}</p>
                                                                                    )}
                                                                                    {selectedAddress && (
                                                                                        <div style={{ marginTop: '10px', padding: '10px', border: '1px solid #ddd' }}>
                                                                                            <strong>Address:</strong> {selectedAddress.split("- Account:")[0]} <br />
                                                                                            <strong style={{ color: 'BLACK' }}>Account: {selectedAddress.split("- Account:")[1]}</strong>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            </>
                                                                        }
                                                                    </div>
                                                                }

                                                                {
                                                                    Accountdata?.isDropShipEnable == true && <div className="col-md-5 mb-2 mpadd">
                                                                        <div className="custom-control custom-control-sm custom-switch">
                                                                            <input
                                                                                type="checkbox"
                                                                                className="custom-control-input"
                                                                                id="customSwitch8"
                                                                                checked={isDropShipping}
                                                                                onChange={handleDropShippingToggle}
                                                                            />
                                                                            <label
                                                                                className="custom-control-label"
                                                                                htmlFor="customSwitch8"
                                                                                {...(isDropShipping == false ? {
                                                                                    "data-bs-toggle": "modal",
                                                                                    "data-bs-target": "#dropShipping"
                                                                                } : {})}
                                                                            >
                                                                                Drop Shipping
                                                                            </label>
                                                                        </div>
                                                                        {isDropShipping && !dropShippingData?.addressLine1 && (
                                                                            <div className="mt-2 p-2 bg-warning bg-opacity-10 border border-warning rounded d-flex justify-content-between align-items-center">
                                                                                <span className="text-warning">⚠️ Please enter drop shipping address</span>
                                                                                {/* <button
                                                                                    type="button"
                                                                                    className="btn btn-sm btn-warning"
                                                                                    data-bs-toggle="modal"
                                                                                    data-bs-target="#dropShipping"
                                                                                >
                                                                                    Enter Address
                                                                                </button> */}
                                                                            </div>
                                                                        )}
                                                                        {isDropShipping && (
                                                                            <div className="dropShippingField mt-2 p-2 border rounded d-flex align-items-center justify-content-between">
                                                                                <span className="text-truncate" style={{ maxWidth: "80%" }}>
                                                                                    {dropShippingData?.addressLine1}{dropShippingData?.city && ","} {dropShippingData?.city}{dropShippingData?.state && ","} {dropShippingData?.state}
                                                                                </span>
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-link text-primary"
                                                                                    data-bs-toggle="modal"
                                                                                    data-bs-target="#dropShipping"
                                                                                >
                                                                                    ✏️ Edit
                                                                                </button>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                }
                                                            </div>
                                                            <br></br>
                                                            <div className="col-md-12 mt-3">
                                                                <button type="submit" className="addBtnCustomer">Continue</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Drop Shipping Modal with Google Maps Autocomplete */}
            <div className="modal fade" tabIndex="-1" id="dropShipping">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Drop Shipping</h5>
                            <a href="#" className="close" data-bs-dismiss="modal" aria-label="Close">
                                <em className="icon ni ni-cross-c"></em>
                            </a>
                        </div>

                        {/* Google Autocomplete z-index Fix */}
                        <style jsx>{`
                .pac-container {
                    z-index: 1060 !important;
                }
            `}</style>

                        <form onSubmit={(e) => {
                            e.preventDefault();
                            handleSubmitShipping(onDropShippingSubmit)();
                        }}>
                            <div className="modal-body inputCardBox">
                                <div className="row">
                                    <div className="col-md-12 mb-2">
                                        <h6 className="instructionHeading">
                                            Drop shipment are charged all shipping costs, plus a $10 fee per address per week.
                                            RS labels are included inside each box unless otherwise requested.
                                        </h6>
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <label>Name  <span className="text-danger">*</span></label>
                                        <input
                                            type="text"
                                            className={`form-control ${shippingErrors.name ? 'is-invalid' : ''}`}
                                            placeholder="Enter Name"
                                            defaultValue={initialValues?.dropShipping?.name || ""}
                                            {...registerShipping("name", {
                                                required: "Name is required",
                                                value: initialValues?.dropShipping?.name || ""
                                            })}
                                        />
                                        {shippingErrors.name && <p className="red">{shippingErrors.name.message}</p>}
                                    </div>

                                    {/* Address Line 1 with Google Autocomplete */}
                                    <div className="col-md-12 mb-3">
                                        <label>Address line 1<span className="text-danger">*</span> </label>
                                        <input
                                            id="modal-address-input"
                                            type="text"
                                            className={`form-control ${shippingErrors.addressLine1 ? 'is-invalid' : ''}`}
                                            placeholder="Start typing address..."
                                            {...registerShipping("addressLine1", { required: "Address is required" })}
                                            onChange={handleModalAddressChange}
                                        />
                                        <div className="text-xs text-gray-500 mt-1">
                                            Start typing to see address suggestions
                                        </div>
                                        {shippingErrors.addressLine1 && <p className="red">{shippingErrors.addressLine1.message}</p>}
                                    </div>

                                    <div className="col-md-12 mb-3">
                                        <label>Address line 2</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Address line 2"
                                            {...registerShipping("addressLine2")}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label>City </label>
                                        <input
                                            type="text"
                                            className={`form-control ${shippingErrors.city ? 'is-invalid' : ''}`}
                                            placeholder="Enter City"
                                            {...registerShipping("city")}
                                            onChange={handleModalCityChange}
                                        />
                                        {shippingErrors.city && <p className="red">{shippingErrors.city.message}</p>}
                                    </div>
                                    <div className="col-md-6 mb-3 stateSelect">
                                        <label>State </label>
                                        <Controller
                                            name="state"
                                            control={control}
                                            render={({ field, fieldState: { error } }) => (
                                                <div>
                                                    <Select
                                                        {...field}
                                                        options={getState.map(item => ({
                                                            value: item.name,
                                                            label: item.name
                                                        }))}
                                                        placeholder="Select state"
                                                        onChange={handleModalStateChange}
                                                        value={getState.map(item => ({
                                                            value: item.name,
                                                            label: item.name
                                                        })).find(option => option.value === field.value) || null}
                                                        className={error ? 'is-invalid' : ''}
                                                    />
                                                    {error && <p className="red">{error.message}</p>}
                                                </div>
                                            )}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label>Zip Code </label>
                                        <input
                                            type="text"
                                            className={`form-control ${shippingErrors.zipCode ? 'is-invalid' : ''}`}
                                            placeholder="Enter Zip Code"
                                            {...registerShipping("zipCode", {
                                                pattern: {
                                                    value: /^\d+$/,
                                                    message: "Please enter a valid zip code"
                                                }
                                            })}
                                            onInput={handleModalZipChange}
                                        />
                                        {shippingErrors.zipCode && <p className="red">{shippingErrors.zipCode.message}</p>}
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label>Phone <span className="text-danger">*</span> </label>
                                        <input
                                            type="text"
                                            className={`form-control ${shippingErrors.phone ? 'is-invalid' : ''}`}
                                            placeholder="(XXX) XXX-XXXX"
                                            maxLength="14"
                                            {...registerShipping('phone', {
                                                required: "Phone number is required",
                                                onChange: handleChangemo,
                                                pattern: {
                                                    value: /^\(\d{3}\) \d{3}-\d{4}$/,
                                                    message: "Please enter a valid phone number"
                                                }
                                            })}
                                        />
                                        {shippingErrors.phone && <p className="red">{shippingErrors.phone.message}</p>}
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-md-4 mb-3">
                                        <button type="submit" className="addBtnCustomer">Add Ship</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Container >
    )
}

export default MemberDetail;